<template lang="html">
  <transition name="fade">
    <div class="warning" v-show="show && showCookieWarning && !hasCookie">
      <div class="text">
        This website uses cookies for analytics. By using this website you agree
        to the use of cookies.
      </div>
      <div class="link" @click="hideWarning">
        <h3>OK</h3>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      hasCookie: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.showWarning);
    let cookie = this.$cookie.get("aspekt_office");
    this.hasCookie = cookie;
  },
  computed: {
    showCookieWarning() {
      return this.$store.state.showCookieWarning;
    }
  },
  methods: {
    showWarning() {
      if (window.scrollY > 30) {
        this.show = true;
      }
    },
    hideWarning() {
      this.$store.state.showCookieWarning = false;
      this.$cookie.set("aspekt_office", true, 60);
    }
  }
};
</script>

<style lang="scss" scoped>
.warning {
  position: fixed;
  bottom: var(--lh);
  left: 50%;
  transform: translate(-50%, 0);
  backdrop-filter: blur(5px);
  background: rgba(255, 255, 255, 0.8);
  z-index: 999;
  display: flex;
  align-items: center;
  font-size: calc(0.8 * var(--fs));
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  > div {
    padding: calc(0.5 * var(--lh)) var(--lh);
  }
  @media only screen and (max-width: 768px) {
    font-size: calc(0.7 * var(--fs));
    line-height: 1.2;
    width: calc(100% - (2 * var(--lh)));
  }
}
</style>
